module.exports = __webpack_public_path__ + "img/wan.c58949f8.svg";